module.exports = __webpack_public_path__ + "media/brand/AppCarMP-8941cc9a.png";